import { Component, Vue, Prop } from 'vue-property-decorator';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import { validationRules } from '@/support/ValidationRules';
import { Category } from '@/models/Category';
import { SubCategory } from '@/models/SubCategory';

@Component<CreateSubCategoryDialog>({})
export default class CreateSubCategoryDialog extends Vue {
  @Prop({default: null})
  protected category!: Category;

  protected newSubCategory: SubCategory = new SubCategory();
  protected isLoading: boolean = true;
  protected valid: boolean = false;
  protected rules: object = validationRules(this.getTranslation);
  protected subCategoryName: string  = '';

  mounted() {
    if(this.category) {
      this.newSubCategory.category = this.category.id;
    }
  }

  private getTranslation(key: string) {
    return this.$t(key);
  }

  protected close() {
    this.$emit('input', false);
    this.clear();
  }

  protected create() {
    this.isLoading = true;

    this.newSubCategory
    .create()
    .then((subcategory: SubCategory) => {
      this.isLoading = false;
      this.$emit('subCategoryCreated');
      this.close();
    })
    .catch((error: AxiosError) => {
      ErrorHandler.network(error);
    });
  }

  protected get canSaveCategory() {
    if(this.newSubCategory.name) {
      return true;
    }

    return false;
  }

  protected get saveButtonText() {
    return 'Add';
  }

  protected clear() {
    this.newSubCategory = new SubCategory();
  }
}
